import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { RESET_EXPERT_TYPING } from '../../store/actions/experts';

import Message from '../Messages/Message';

import s from './index.module.css';

const TYPING_TEXT = 'Пишет';
const TYPING_RESET_TIMER_MS = 5000;

const ExpertTyping = ({
  isTyping, // boolean indicating if expert is typing
  typingExpert, // object w info about typing expert - avatar, name, senderId, expertId, senderType
  isAnotherSender, // boolean indicating that prev message was from different user
}) => {
  const dispatch = useDispatch();
  const { name, avatarUrl, typeId, senderId } = typingExpert;

  useEffect(() => {
    let typingTimer = setTimeout(() => {
      dispatch({ type: RESET_EXPERT_TYPING, payload: senderId });
    }, TYPING_RESET_TIMER_MS);

    return () => {
      clearTimeout(typingTimer);
    }
  }, [isTyping, senderId, dispatch]);

  return isTyping && (
    <Message
      senderType={typeId}
      userName={name}
      avatarUrl={avatarUrl}
      isAnotherSender={isAnotherSender}
      messageContent={TYPING_TEXT}
      isExpertMessage
    >
      <span className={s.typingText}>
        {TYPING_TEXT}
        <span></span>
        <span></span>
        <span></span>
      </span>
    </Message>
  );
};

export default ExpertTyping;